import { Component } from '@angular/core';
import { SkeletonLoaderComponent } from '../skeleton-loader/skeleton-loader.component';

@Component({
  selector: 'app-meal-card-skeleton',
  standalone: true,
  imports: [SkeletonLoaderComponent],
  templateUrl: './meal-card-skeleton.component.html',
  styleUrl: './meal-card-skeleton.component.scss'
})
export class MealCardSkeletonComponent {}

